import { FaFilePdf } from "react-icons/fa";
import { CDN_URL } from "../Helpers";

export default function OneService({ data }) {

  return (
    <div
      className="card border-0 mShadow1 mb-4"
      style={{
        borderRadius: "12px",
        padding: "20px",
        borderLeft: "4px solid var(--secondaryColor)"
      }}
    >

      <div className="d-flex align-items-start gap-3">

        {/* PDF ICON */}
        <FaFilePdf
          size={45}
          style={{ color: "var(--primaryColor)", flexShrink: 0 }}
        />

        <div style={{ flex: 1 }}>

          {/* TITLE */}
          <h6
            style={{
              fontFamily: "FontBold",
              color: "var(--primaryColor)",
              marginBottom: "8px"
            }}
          >
            {data.title}
          </h6>

          {/* DESCRIPTION */}
          <p
            style={{
              fontSize: "14px",
              color: "#555",
              marginBottom: "10px"
            }}
          >
            {data.description}
          </p>

          {/* META */}
          <div
            style={{
              fontSize: "13px",
              color: "#777",
              marginBottom: "15px"
            }}
          >
            {data.date} • {data.size}
          </div>

          {/* DOWNLOAD BUTTON */}
          <a
            href={CDN_URL + data.file}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary btn-sm text-light"
          >
            Download
          </a>

        </div>

      </div>
    </div>
  );
}